<div class="ts-comments" [class.standalone]="!cssClass">
  <div class="ts-comments-loader" *ngIf="loading">
    <mat-spinner diameter="40"></mat-spinner>
  </div>

  <div class="ts-comments-list" *ngIf="commentsList?.length">
    <div class="ts-comment" *ngFor="let comment of commentsList">
      <div class="ts-comment-head">
        <div class="ts-comment-avatar">
          {{ authService.getInitials(comment.comment_by) }}
        </div>
        <div class="ts-comment-meta">
          <span class="name">{{ comment.comment_by }}</span>
          <span class="when">
            {{ dataSharedService.getFormatedDate(comment.created_at) }}, {{ comment.created_at | date: 'hh:mm a' }}
          </span>
        </div>
      </div>
      <p class="ts-comment-body" [innerText]="comment.comment"></p>
    </div>
  </div>

  <div class="ts-comments-empty" *ngIf="!loading && !commentsList?.length">
    <div class="ico"><i class="bi bi-chat-left-text"></i></div>
    <h3>No comments yet</h3>
    <p>Add the first comment so the rest of the team has context.</p>
  </div>

  <form class="ts-comment-form" [formGroup]="commentForm" (ngSubmit)="onComment()">
    <textarea
      class="input-form"
      formControlName="comment"
      placeholder="Type a comment…"></textarea>
    <div class="ts-comment-actions">
      <button type="submit" class="btn btn-primary" [disabled]="!commentForm.valid || loading">
        <i class="bi bi-send"></i>
        <span>Send</span>
      </button>
    </div>
  </form>
</div>
